import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { SessionStateService } from "../../core/services/session-state.service";

@Component({
  selector: "app-efficiency",
  templateUrl: "./efficiency.component.html",
  styleUrls: ["./efficiency.component.scss"],
})
export class EfficiencyComponent implements OnInit {
  menu: String[] = [];
  hasType = false;
  constructor(private sessionStateService: SessionStateService) {}

  ngOnInit() {
    this.menu.push("REDY TIPS");
    //this.menu.push('SAVINGS');
    // this.menu.push('NEIGHBORS COMPARISON');
    //this.menu.push('ACHIEVEMENTS');
  }

  changeTab(event) {
    this.hasType = event;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/efficiency/efficiency.component.ts